export default __webpack_public_path__ + "static/media/women-9.58825b20.jpg";